import { Component, Prop, Vue } from 'nuxt-property-decorator';

import Close from '../../assets/svg/x.svg';

@Component<Tooltip>({
  components: {
    Close
  }
})
export default class Tooltip extends Vue {
  @Prop()
  icon!: any;

  @Prop()
  arrow!: 'top-left' | 'top-center' | 'top-right' |
    'right-top' | 'right-center' | 'right-bottom' |
    'left-top' | 'left-center' | 'left-bottom' |
    'bottom-left' | 'bottom-center' | 'bottom-right';

  @Prop({ type: String, default: 'none' })
  width!: string;

  @Prop({ type: String, default: 'none' })
  height!: string;

  @Prop({ type: Boolean, default: true })
  borderRadius!: boolean;

  @Prop()
  steps?: [{
    title: string;
    paragraph: string;
    action: string;
  }];

  // Type
  @Prop({ type: Boolean, default: false })
  tutorial!: boolean;

  step: number = 1;
  maxStep: number = this.steps && this.steps.length || 0;

  get hasIcon(): boolean {
    return !!this.icon;
  }

  get hasArrow(): boolean {
    return !!this.arrow;
  }

  get hasTitle(): boolean {
    return !!this.$slots.title || !!this.currentStep.title;
  }

  get hasSlotTitle(): boolean {
    return !!this.$slots.title;
  }

  get hasParagraph(): boolean {
    return !!this.$slots.paragraph;
  }

  get arrowClass(): string {
    return `tooltip--${this.arrow}`;
  }

  get currentStep(): {
    title: string;
    paragraph: string;
    action: string;
  } {
    if (this.steps) {
      return this.steps[this.step - 1];
    }

    return {
      title: '',
      paragraph: '',
      action: '',
    };
  }

  nextStep(e: any): void {
    if (this.step + 1 <= this.maxStep) {
      e.preventDefault();

      this.step += 1;

      this.$emit('nextStep', e);
    } else {
      this.close(e);
    }
  }

  close(e: any): void {
    e.preventDefault();

    this.$emit('close', e);
  }
}
